/** @description Получение настроек дефолтного контрола
 * @param {EControlType} controlType тип контрола для которого получаем настройки
 * @param {IControl[]} controlSettings массив настроек контролов
 * @return {IControl | null}
 */
export function getControlSettings(controlType, controlSettings) {
  var result = null;
  controlSettings.forEach(function (item) {
    if (item.type === controlType) {
      result = item;
    }
  });
  return result;
}